import React from "react";
import Heading from "../../components/Heading/Heading";
import SkillIcons from "../../components/Skillicons/Skillicons";
import SkillsCSS from "./CSS/Skills.module.css";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { solid, regular, brands, icon } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FaHandPointRight } from "react-icons/fa";

export default function Skills() {
  return (
    <>
      <div className={SkillsCSS.container} id="skills">
        <div className={SkillsCSS.skillPage}>
          <Heading heading="Skills" before="My" />

          <div className={SkillsCSS.skillContainer}>
            <div
              className={SkillsCSS.image}
              style={{
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                
               
              }}
            >
              <img src="./images/programming.gif" alt="1st_image" />
            </div>
            <div className={SkillsCSS.img}>
              <h1 className={SkillsCSS.heading}>Full Stack Development</h1>

              <div className={SkillsCSS.skillIcons}>
                <SkillIcons img="https://cdn-icons-png.flaticon.com/512/1051/1051277.png" />
                <SkillIcons img="https://cdn-icons-png.flaticon.com/512/732/732190.png" />
                <SkillIcons img="https://cdn-icons-png.flaticon.com/512/5968/5968292.png" />
                <SkillIcons img="https://cdn-icons-png.flaticon.com/512/5968/5968672.png" />
                <SkillIcons img="https://cdn-icons-png.flaticon.com/512/1126/1126012.png" />
                <SkillIcons img="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Node.js_logo.svg/1280px-Node.js_logo.svg.png" />
                <SkillIcons img="https://assets.website-files.com/61ca3f775a79ec5f87fcf937/6202fcdee5ee8636a145a41b_1234.png" />
                <SkillIcons img="https://www.opc-router.de/wp-content/uploads/2021/03/mongodb_thumbnail.png" />
                <SkillIcons img="https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png" />
              </div>

              <ul className={SkillsCSS.desc}>
                <li>
                  <span>
                    <FaHandPointRight />
                  </span>{" "}
                  Develop highly interactive User Interfaces and Backend for web
                  applications
                </li>
                <li>
                  {" "}
                  <span>
                    <FaHandPointRight />
                  </span>{" "}
                  Building responsive website front end using ReactJS
                </li>
                <li>
                  <span>
                    <FaHandPointRight />
                  </span>{" "}
                  Creating application backend in Node, Express,
                </li>
              </ul>
            </div>

            <div className={SkillsCSS.img}>
              <h1 className={SkillsCSS.heading}>Cloud Infra-Architecture</h1>

              <div className={SkillsCSS.skillIcons}>
                <SkillIcons img="https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png" />
                <SkillIcons img="https://camo.githubusercontent.com/add2c9721e333f0043ac938f3dadbc26a282776e01b95b308fcaba5afaf74ae3/68747470733a2f2f6173736574732e76657263656c2e636f6d2f696d6167652f75706c6f61642f76313538383830353835382f7265706f7369746f726965732f76657263656c2f6c6f676f2e706e67" />
                <SkillIcons img="https://cdn4.iconfinder.com/data/icons/google-i-o-2016/512/google_firebase-2-512.png" />
                <SkillIcons img="https://avatars.githubusercontent.com/u/65916846?v=4?s=100" />
              </div>

              <ul className={SkillsCSS.desc}>
                <li>
                  {" "}
                  <span>
                    <FaHandPointRight />
                  </span>
                  Experience working on multiple cloud platforms
                </li>
                <li>
                  <span>
                    <FaHandPointRight />
                  </span>{" "}
                  Experience hosting and managing websites
                </li>
                <li>
                  <span>
                    <FaHandPointRight />
                  </span>
                  Experience with Continuous Integration
                </li>
              </ul>
            </div>
            <div
              className={SkillsCSS.image}
              style={{
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "auto",
                
              }}
            >
              <img src="./images/developer.gif" alt="2nd_image" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
